import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Editor from 'react-tinymce';

export default class Campaign extends Base {
    constructor(props) {
        super(props);
        this.state = {
            isOrganization: props.IsOrganization,
            inlineFilter: (this.isNull(props.InlineFilter) ? false : props.InlineFilter),
            service: props.Service,
            caller: props.Caller,
            emails: props.Emails,
            data: null,
            loading: true,
            template: '',
            title: '',
            note: '',
            systemModuleId: 31,
            moduleAccessStatus: 1,
            service: props.Service,
            filters: '',
            templates: []
        };
        if (this.state.inlineFilter) {
            this.state.emails = [];
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        var p1 = this.httpPost("api/v1/common/getsmstemplate", {
            onlySystemTemplates: !this.state.isOrganization,
            useIn: '',
            crmTeams: ''
        })
            .then(data => {
                this.state.templates = data.templates;
            });

        var p2 = this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
            });

        Promise.all([p1, p2]).then(r => {
            this.setState({
                loading: false
            })
        })

    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/campaign/create", {
            service: this.state.service,
            isOrganization: this.state.isOrganization,
            template: this.state.template,
            title: this.state.title,
            note: this.state.note,
            emails: this.state.emails,
            filters: this.state.filters,
            inlineFilter: this.state.inlineFilter
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("کمپین شما ایجاد شد و آماده ارسال می باشد");
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    serService(e) {
        this.state.template = '';
        this.setState({ service: e });
    }
    checkFilters(f, checked) {
        this.state.filters = this.state.filters.replace("[" + f + "]", "");
        if (checked === true) this.state.filters = "[" + f + "]";
    }
    renderForm() {
        if (this.state.moduleAccessStatus == -2) return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        {this.renderSystemModuleNotFound()}
                    </div>
                </div>
            </div>
        </div>
        if (this.state.moduleAccessStatus == -3) return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        {this.renderSystemModuleExpired()}
                    </div>
                </div>
            </div>
        </div>

        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">ایجاد کمپین تبلیغات</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    {/*<div className="col-sm-12 mb-2">*/}
                                    {/*    <div className="form-group">*/}
                                    {/*        <label className="form-label required">نوع کمپین</label>*/}
                                    {/*        <select defaultValue={this.state.service} onChange={e => this.serService(parseInt(e.target.value))} autoComplete="off" type="text" className="form-control">*/}
                                    {/*            <option value="1">ایمیلی</option>*/}
                                    {/*            <option value="2">پیامکی</option>*/}
                                    {/*        </select>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.title} onChange={e => this.state.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="400" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">یادداشت</label>
                                            <input defaultValue={this.state.note} onChange={e => this.state.note = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="400" />
                                        </div>
                                    </div>
                                    {this.state.service === 2 && <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label className="form-label required">متن پیام</label>
                                            <select defaultValue={this.state.template} onChange={e => this.state.template = e.target.value} autoComplete="off" type="text" className="form-control">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.templates.map(template =>
                                                    <option value={template.id}>{template.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>}
                                    {this.state.service === 1 && <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">الگوی متن ایمیل</label><span className="red">*</span>
                                            <Editor
                                                content={this.state.template}
                                                config={{
                                                    convert_urls: false,
                                                    images_upload_handler: (blobInfo, success, failure, progress) => {
                                                        fetch("/api/v1/campaign/upload/", {
                                                            method: "post",
                                                            body: JSON.stringify({ "pic": "data:image/jpeg;base64," + blobInfo.base64() }),
                                                            headers: {
                                                                'Content-Type': 'application/json'
                                                            }
                                                        })
                                                            .then(response => response.json())
                                                            .then(resualt => {
                                                                if (resualt.status == 1) success(resualt.path);
                                                                else failure(resualt.message);
                                                            })
                                                            .catch(err => {
                                                                failure("خطا در آپلود فایل")
                                                            });
                                                        //        this.setState({
                                                        //            picToCrop2: "data:image/jpeg;base64," + blobInfo.base64(),
                                                        //            editorUploaderSuccessCalback: success,
                                                        //            editorUploaderFailorCalback: failure
                                                        //        })
                                                    },
                                                    images_file_types: 'jpg,jpeg,png,webp',
                                                    automatic_uploads: false,
                                                    file_picker_types: 'image',
                                                    language: 'fa_IR',
                                                    directionality: 'rtl',
                                                    paste_as_text: true,
                                                    height: 250,
                                                    plugins: [
                                                        'code textcolor colorpicker image imagetools importcss table preview advlist media lists link autolink paste'
                                                    ],
                                                    toolbar: 'formatselect format code alignleft aligncenter alignright alignjustify rtl ltr forecolor backcolor table format image forecolor backcolor preview media numlist bullist link',
                                                    menubar: "tools insert file edit view format table",
                                                }}
                                                onChange={e => {
                                                    this.state.template = e.target.getContent()
                                                }}
                                            />
                                            <p>برای درج نام شخص در داخل الگو، از متغییر #name#  و برای درج آدرس ایمیل از متغییر #email# استفاده نمایید</p>
                                        </div>
                                    </div>}
                                </div>

                                {this.state.inlineFilter && !this.state.isOrganization && <div className="row">                                    
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <input onChange={e => this.checkFilters('user_company', e.target.checked)} defaultChecked={this.state.filters.includes("[user_company]")} type="checkbox" />
                                            کاربرانی که اقدام به ایجاد کسب و کار نموده اند
                                        </div>
                                    </div>
                                </div>}

                                {this.state.inlineFilter && this.state.isOrganization && <div className="row">
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <input onChange={e => this.checkFilters('person_buy_factor', e.target.checked)} defaultChecked={this.state.filters.includes("[person_buy_factor]")} type="checkbox" />
                                            طرف حسابهای دارای فاکتور خرید
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <input onChange={e => this.checkFilters('person_sale_factor', e.target.checked)} defaultChecked={this.state.filters.includes("[person_sale_factor]")} type="checkbox" />
                                            طرف حسابهای دارای فاکتور فروش
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <input onChange={e => this.checkFilters('person_remittance_in', e.target.checked)} defaultChecked={this.state.filters.includes("[person_remittance_in]")} type="checkbox" />
                                            طرف حسابهای دارای رسید انبار
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <input onChange={e => this.checkFilters('person_remittance_out', e.target.checked)} defaultChecked={this.state.filters.includes("[person_remittance_out]")} type="checkbox" />
                                            طرف حسابهای دارای حواله انبار
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <input onChange={e => this.checkFilters('person_invoice', e.target.checked)} defaultChecked={this.state.filters.includes("[person_invoice]")} type="checkbox" />
                                            طرف حسابهای دارای صورتحساب پذیرش شده مودیان
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <input onChange={e => this.checkFilters('person_bed', e.target.checked)} defaultChecked={this.state.filters.includes("[person_bed]")} type="checkbox" />
                                            طرف حسابهای دارای مانده بدهکار
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <input onChange={e => this.checkFilters('person_bes', e.target.checked)} defaultChecked={this.state.filters.includes("[person_bes]")} type="checkbox" />
                                            طرف حسابهای دارای مانده بستانکار
                                        </div>
                                    </div>
                                </div>}

                                {this.state.inlineFilter && this.state.service === 1 && <p className="mt-2">پیام فوق برای {this.state.emails.length} آدرس ایمیل انتخاب شده ارسال خواهد گردید</p>}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ایجاد کمپین
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}